import { enumWidgetType, enumWidgetTrigger } from "../CoreApp/widgets/widgetTypes";
//================================================
// orgchart version
export const gWhiteLabel = "";
export const gAppName = "OrgChart";
export const gCompanyName = "OrgChart LLC";
export const gUseGenericSupportContact = false;
export const gSupportEmail = "support@theorgchart.com";
export const gAccessGroupLimitKey = "accessGroupLimit";
export const gFormulasLimitKey = "formulasLimit";
export const gAddSourcesLimitKey = "addSourcesLimit";
export const gBoxLimitKey = "The scope of the export exceeds your account's box limit";
export const gUnknownErrorKey = "unknownqerr";
export const gKeyRetrievalFailureKey = "ADPKeyFailure";
export const gSharePointErrorKey = "sharepointqerr";
export const gSupportMsgKey = "SupportMsg";
export const gSalesMsgKey = "SalesMsg";
export const gDemoReqSite =
  "https://go.theorgchart.com/product-upgrade-book-a-demo?utm_campaign=18317853-cs_engagement_position-mgmt-client-expansion_product_2025&utm_source=product&utm_medium=feature-upgrade-cta&utm_term=upgrade-lp-book-a-demo&utm_content=all-users-get-started-cta";
export const gPricingSite =
  "https://theorgchart.com/pricing/?utm_campaign=18317853-cs_engagement_position-mgmt-client-expansion_product_2025&utm_source=product&utm_medium=feature-upgrade-cta&utm_term=oc-pricing-page&utm_content=all-users-learn-more-cta";
export const gSignUpLink = "https://theorgchart.com/";
export const gSalesEmail = "sales@theorgchart.com";
export const gSupportPortal = "https://theorgchart.zendesk.com";
export const gPremiumAppLink =
  "https://apps.adp.com/login?continue=https://apps.adp.com/apps/220877";
export const gADPEnterpriseAppLink =
  "https://apps.adp.com/login?continue=https://apps.adp.com/apps/277412";
export const gPremiumCAAppLink =
  "https://ca.apps.adp.com/login?continue=https://apps.adp.com/apps/190176";
export const gADPVantageAppLink =
  "https://apps.adp.com/login?continue=https://apps.adp.com/apps/140476";
export const gConsentMgrLink = "https://adpapps.adp.com/consent-manager/";
export const gTutorialLink =
  "https://theorgchart.zendesk.com/hc/en-us/articles/21123827718420-OrgChart-Tutorials";
export const gTermsOfService =
  "https://theorgchart.zendesk.com/hc/en-us/articles/21124890627092-Terms-of-Service";
export const gPrivacyPolicy =
  "https://theorgchart.zendesk.com/hc/en-us/articles/21124934514964-Privacy-Policy";
export const gHelpWiki = "https://theorgchart.zendesk.com/hc/en-us";
export const gShowHelpReadOnly = true;
export const enumButtonColors = {
  White: "#FFFFFF",
  Yellow: "#ffff00",
  Orange: "#ed9e49",
  Red: "#ff0000",
  Green: "#00ff00", //'#aadd50'
  Teal: "#00DDDD",
  Blue: "#2f96de",
  Magenta: "#FF00FF",
  Black: "#000000"
};
export var uFramelessPanelColorLighter = "#494958";
export var uFramelessPanelColor = "#3d3d4a";
export var uFramelessPanelColorDarker = "#30303b";
export var uViewerButtonColor = "Orange";
export var uFocusRingColor = "#ed9e49";
export const kImageFiles = [
  "/static/images/appIcons.svg",
  "/static/images/enable16.png",
  "/static/images/ocnlogo.png",
  "/static/images/html5icon.png",
  "/static/images/ocnlogo2.png",
  "/static/images/viewerIcons.svg",
  "/static/images/enable48drag.png",
  "/static/images/premiumpaywall.png",
  "/static/images/enableconnectors96.png",
  "/static/images/enable256.png",
  "/static/images/chartsettings.svg",
  "/static/images/accountsettings.svg",
  "/static/images/backgroundeditor.svg",
  "/static/images/viewmanager.svg",
  "/static/images/apistart.svg",
  "/static/images/flatfilestart.svg",
  "/static/images/manualstart.svg",
  "/static/images/uploadfile.svg",
  "/static/images/endmark.png",
  "/static/images/endmark_inverse.png",
  "/static/images/add.svg",
  "/static/images/comment.svg",
  "/static/images/delete.svg",
  "/static/images/edit.svg",
  "/static/images/lock.svg",
  "/static/images/move.svg",
  "/static/images/moveout.svg",
  "/static/images/add-flat.svg",
  "/static/images/comment-flat.svg",
  "/static/images/delete-flat.svg",
  "/static/images/edit-flat.svg",
  "/static/images/move-flat.svg",
  "/static/images/moveout-flat.svg",
  "/static/images/gear-flat.svg",
  "/static/images/users.svg",
  "/static/images/user-plus.svg",
  "/static/images/user-minus.svg",
  // position plan overlay images
  "/static/images/position-add.svg", // position added
  "/static/images/position-change.svg", // position or employee changed,
  "/static/images/position-comment.svg", // employee comment
  "/static/images/position-delete.svg", // position deleted, or employee released
  "/static/images/position-move.svg", // employee moved, moved out, or position moved, moved out
  "/static/images/position-unassign.svg" // employee unassigned
];
export const gStoreLink =
  "https://sites.fastspring.com/orgchartpro.com/instant/orgchartnowstore1cloudorgchartsolution";
export const gVideosLink = "https://www.youtube.com/channel/UCFaI1wt7jNuePUtSNVNOiLw/videos";
export const gFreeTrialLink =
  "https://www.orgchartpro.com/products/orgchart-now-2/orgchart-now-free-trial/";
export const gBrowserLink = "https://www.orgchartpro.com/products/orgchart-now-2/browsereq/";
export const gExpireInfo = "https://www.orgchartpro.com/products/orgchart-now-2/expireinfo/";
export const gWidgets = {
  [enumWidgetType.pendo]: { trigger: enumWidgetTrigger.help },
  [enumWidgetType.onramp]: { trigger: enumWidgetTrigger.passive }
};
export const gMainWebSite = "www.orgchartpro.com";
export const gStayConnectedEnable = true;
export const kMaxRecSinglePage = 5000;
export const kNavLogo = "/static/images/OC-logo.png";
export const kFavIcon = "/static/images/favicon_oc.png";
export const kFavIconNotif = "/static/images/faviconnotif_oc.png";
export const kPoweredByLogo = "";
export const kConfigConnectorList = [
  {
    connector: "Chart Builder",
    hover: "querydata",
    icon: "chartbuilder",
    import: "builderimport",
    command: "builderconfig"
  },
  {
    connector: "Excel/CSV",
    hover: "excelimport",
    icon: "excelapp",
    import: "excelimport",
    command: "None"
  },
  {
    connector: "ADP",
    hover: "adpconnect",
    icon: "adp",
    import: "adpimport",
    command: "adpworkforcenow"
  },
  {
    connector: "BambooHR",
    hover: "bambooconnect",
    icon: "bamboohr",
    import: "bambooimport",
    command: "bamboohr"
  },
  {
    connector: "PeopleHR",
    hover: "peoplehrconnect",
    icon: "peoplehr",
    import: "peoplehrimport",
    command: "peoplehr"
  },
  {
    connector: "SAP XML",
    hover: "sapxmlconnect",
    icon: "sapxml",
    import: "sapxmlimport",
    command: "sapxml"
  },
  {
    connector: "SAP RFC",
    hover: "sapconnect",
    icon: "sap",
    import: "sapimport",
    command: "sap"
  },
  {
    connector: "UKG Pro (Raas)",
    hover: "ultiproconnect",
    icon: "ukg",
    import: "ultiproimport",
    command: "ultipro"
  },
  {
    connector: "Salesforce",
    hover: "salesforceconnect",
    icon: "salesforce",
    import: "salesforceimport",
    command: "salesforce"
  },
  {
    connector: "breatheHR",
    hover: "breathehrconnect",
    icon: "breathehr",
    import: "breathehrimport",
    command: "breathehr"
  },
  {
    connector: "PaySpace",
    hover: "payspaceimport",
    icon: "payspace",
    import: "payspaceimport",
    command: "payspace"
  },
  {
    connector: "Namely",
    hover: "namelyconnect",
    icon: "namely",
    import: "namelyimport",
    command: "namely"
  },
  {
    connector: "Greenhouse",
    hover: "greenhouseconnect",
    icon: "greenhouse",
    import: "None",
    command: "greenhouse"
  },
  {
    connector: "Jobvite",
    hover: "jobviteconnect",
    icon: "jobvite",
    import: "None",
    command: "jobvite"
  },
  {
    connector: "iCIMS",
    hover: "icimsconnect",
    icon: "icims",
    import: "None",
    command: "icims"
  },
  {
    connector: "Workday",
    hover: "workdayconnect",
    icon: "workday",
    import: "workdayimport",
    command: "workday"
  }
];
export const kEnterpriseConnectorList = [
  { connector: "BambooHR", icon: "bamboohr", command: "Bamboo" },
  { connector: "BreatheHR", icon: "breathehr", command: "BreatheHR" },
  { connector: "CSV", icon: "csv", command: "CSV" },
  { connector: "Canada", icon: "adp", command: "ADP Canada" },
  { connector: "Cornerstone", icon: "cornerstone", command: "Cornerstone" },
  { connector: "Dayforce", icon: "dayforce", command: "Dayforce" },
  { connector: "Enterprise", icon: "adp", command: "ADP Enterprise" },
  { connector: "Entra ID", icon: "azure", command: "AzureAD" },
  { connector: "Europe", icon: "adp", command: "ADP Europe" },
  { connector: "Excel", icon: "excelapp", command: "XLS" },
  {
    connector: "Google Directory",
    icon: "google",
    command: "Google Directory"
  },
  { connector: "isolved", icon: "isolved", command: "isolved" },
  { connector: "Jemini", icon: "Jemini", command: "Jemini" },
  { connector: "Lyric", icon: "adpng", command: "ADP Lifion" },

  { connector: "Namely", icon: "namely", command: "Namely" },
  {
    connector: "WFN Next Generation",
    icon: "adpng",
    command: "WFN Next Generation"
  },
  //{"connector":"Next Generation HCM",	"icon":"adpng",		"command":"ADP NG HCM"},
  //{ connector: "EYWP", icon: "OPP", command: "OPP" }
  { connector: "OrgChart API", icon: "unicorn", command: "ocAPI" },
  { connector: "Oracle", icon: "Oracle", command: "Oracle" },
  { connector: "OrangeHRM", icon: "orangehrm", command: "OrangeHRM" },
  { connector: "PaySpace", icon: "payspace", command: "PaySpace" },
  { connector: "Paychex", icon: "Paychex", command: "Paychex" },
  { connector: "Paycom", icon: "Paycom", command: "Paycom" },
  { connector: "Paycor", icon: "Paycor", command: "Paycor" },
  { connector: "Rippling", icon: "Rippling", command: "Rippling" },
  { connector: "Paylocity", icon: "Paylocity", command: "paylocity" },
  { connector: "PeopleHR", icon: "Peoplehr", command: "PeopleHR" },
  { connector: "SAP RFC", icon: "sap", command: "SAP RFC" },
  { connector: "SAP XML", icon: "sapxml", command: "SAP XML" },
  { connector: "SAP TXT", icon: "sapxml", command: "SAP" },
  { connector: "Sage", icon: "Sage", command: "Sage" },
  { connector: "Sage 300 ZA", icon: "Sage", command: "Sage 300 ZA" },
  { connector: "Salesforce", icon: "Salesforce", command: "Salesforce" },
  { connector: "Signify", icon: "Signify", command: "Signify" },
  //{ connector: "Subscribe-HR", icon: "subscribehr", command: "SubscribeHR" },
  {
    connector: "SuccessFactors",
    icon: "successfactors",
    command: "SuccessFactors"
  },
  { connector: "Thrive TRM", icon: "thriveTRM", command: "Thrive TRM" },
  { connector: "TriNet", icon: "trinet", command: "TriNet" },
  { connector: "UKG Pro", icon: "ukg", command: "UKG" },
  { connector: "UKG Pro (RaaS)", icon: "ukg", command: "Ultipro" },
  { connector: "UKG Ready", icon: "ukg", command: "UKG Ready" },
  { connector: "UnicornHRO", icon: "unicorn", command: "UnicornHRO" },
  { connector: "Vantage", icon: "adp", command: "Vantage" },
  { connector: "Workday (RaaS)", icon: "workday", command: "Workday" },
  { connector: "Workday (API)", icon: "workday", command: "WorkdayAPI" },
  { connector: "Workforce Now", icon: "adp", command: "ADP" }
];
export const kAppendConnectorList = [
  {
    connector: "ADP Recruit Management",
    icon: "adprecmanagement",
    command: "ADP Recruit Management"
  },
  {
    connector: "ADP WFN Recruitment Module",
    icon: "adpr",
    command: "ADP Recruitment"
  },
  {
    connector: "ADP WFN CA Recruitment Module",
    icon: "adpr",
    command: "ADP WFN CA Recruitment Module"
  },
  { connector: "Append Table", icon: "custom", command: "Append Table" }, // TODO replace with proper append table icon
  { connector: "BambooHR", icon: "bamboohr", command: "Bamboo" },
  { connector: "Canada", icon: "adp", command: "ADP Canada" },
  //{ connector: "Clear Company", icon: "clearcompany", command: "ClearCompany" },
  { connector: "Cornerstone", icon: "cornerstone", command: "Cornerstone" },
  { connector: "CSV", icon: "csv", command: "CSV" },
  { connector: "Dayforce", icon: "dayforce", command: "Dayforce" },
  { connector: "Enterprise", icon: "adp", command: "ADP Enterprise" },
  { connector: "Entra ID", icon: "azure", command: "AzureAD" },
  { connector: "Excel", icon: "excelapp", command: "XLS" },
  { connector: "Europe", icon: "adp", command: "ADP Europe" },
  { connector: "Greenhouse", icon: "greenhouse", command: "Greenhouse" },
  { connector: "iCIMS", icon: "icims", command: "ICIMS" },
  { connector: "isolved", icon: "isolved", command: "isolved" },
  { connector: "Jobvite", icon: "jobvite", command: "Jobvite" },
  { connector: "Lever", icon: "lever", command: "Lever" },
  { connector: "Paychex", icon: "paychex", command: "Paychex" },
  { connector: "Paycom", icon: "paycom", command: "Paycom" },
  { connector: "Paycor", icon: "Paycor", command: "Paycor" },
  { connector: "Rippling", icon: "Rippling", command: "Rippling" },
  { connector: "Paylocity", icon: "paylocity", command: "paylocity" },
  { connector: "PaySpace", icon: "payspace", command: "PaySpace" },
  { connector: "PeopleHR", icon: "peoplehr", command: "PeopleHR" },
  { connector: "Thrive TRM", icon: "thriveTRM", command: "Thrive TRM" },
  { connector: "TriNet", icon: "trinet", command: "TriNet" },
  { connector: "UKG Pro (RaaS)", icon: "ukg", command: "Ultipro" },
  { connector: "UKG Ready", icon: "ukg", command: "UKG Ready" },
  {
    connector: "SuccessFactors",
    icon: "successfactors",
    command: "SuccessFactors"
  },
  { connector: "Vantage", icon: "adp", command: "Vantage" },
  { connector: "Workday (RaaS)", icon: "workday", command: "Workday" },
  { connector: "Workforce Now", icon: "adp", command: "ADP" },
  { connector: "Oracle", icon: "Oracle", command: "Oracle" },
  { connector: "OrgChart API", icon: "unicorn", command: "ocAPI" }
];
export const kMergeConnectorList = [
  { connector: "ADP Detailed", icon: "adp", command: "ADP Detail" },
  { connector: "BambooHR", icon: "bamboohr", command: "Bamboo" },
  { connector: "CSV", icon: "csv", command: "CSV" },
  { connector: "Entra ID", icon: "azure", command: "AzureAD" },
  { connector: "Excel", icon: "excelapp", command: "XLS" },
  { connector: "isolved", icon: "isolved", command: "isolved" },
  { connector: "Paychex", icon: "paychex", command: "Paychex" },
  { connector: "Paycom", icon: "paycom", command: "Paycom" },
  { connector: "Paycor", icon: "Paycor", command: "Paycor" },
  { connector: "Rippling", icon: "Rippling", command: "Rippling" },
  { connector: "Paylocity", icon: "paylocity", command: "paylocity" },
  { connector: "Paylocity NextGen", icon: "paylocity", command: "paylocity_nextgen" },
  { connector: "PeopleHR", icon: "peoplehr", command: "PeopleHR" },
  {
    connector: "SuccessFactors",
    icon: "successfactors",
    command: "SuccessFactors"
  },
  { connector: "UKG Pro (API)", icon: "ukg", command: "UKG" },
  { connector: "UKG Ready", icon: "ukg", command: "UKG Ready" },
  { connector: "Oracle", icon: "Oracle", command: "Oracle" },
  { connector: "Workday (RaaS)", icon: "workday", command: "Workday" },
  { connector: "OrgChart API", icon: "unicorn", command: "ocAPI" }
];
export const kPhotoConnectorList = [
  { connector: "Entra ID", icon: "azure", command: "AzureAD" },
  { connector: "Igloo", icon: "Igloo", command: "Igloo" },
  { connector: "Workday", icon: "workday", command: "Workday" },
  { connector: "Oracle", icon: "Oracle", command: "Oracle" }
];
export const kConnectorToggleDict = {
  "Excel/CSV": true,
  ADP: true,
  BambooHR: true,
  PeopleHR: true,
  "SAP XML": true,
  "SAP RFC": true,
  ODBC: true,
  "Subscribe-HR": true,
  UltiPro: true,
  SutiHR: false,
  Salesforce: true,
  breatheHR: true,
  SuccessFactors: true,
  "Google Directory": true,
  TriNet: true,
  OrangeHRM: true,
  Namely: true,
  Greenhouse: true,
  Jobvite: true,
  iCIMS: true,
  "Active Directory": true,
  Paylocity: true,
  "Paylocity NextGen": true,
  Paycor: true,
  PaySpace: true,
  Rippling: true,
  AzureAD: true,
  Workday: true,
  Cornerstone: true,
  Custom: false,
  chartbuilder: false
};

export const showAttachAttributesToggle = false;
export const gBrandingDefaults = {
  brandingFill: "#FEF6EE",
  brandingBorder: "#ED9E49"
};
export const gOrgchartApiSyncOverrideMessage = "";
export const gDistinguishNullFieldValues = false;

export const gUseBannerErrorAlert = false;
export const gShowMainNavigation = true;
// INS-7: AI agent profile cards (runtime card fork + Chart Settings section).
export const gAgentProfilesEnabled = false;
export const gAgentViewColors = null;
export const gNoQueryResultsTitle = "querybuilddataerr";
export const gNoQueryResultsAdmin = "noqueryresults";
export const gNoQueryResultsUser = "noqueryresults";
export const gMissingJobIdTitle = "querybuilddataerr";
export const gMissingJobIdAdmin = "noqueryresults";
export const gMissingJobIdUser = "noqueryresults";
export const gMappingScenarioStrings = {};
// Suppresses UpgradePopover's popover content while still rendering its trigger (pill/custom trigger)
// Pendo now powers upgrade guide messaging for direct clients (VIZ-47)
export const gSuppressUpgradePopovers = true;
// Omits the feature_clicked UTM param from UpgradeButtons' Get started/Learn more URLs
export const gSuppressFeatureClickedParam = false;
// Makes UpgradeButtons' Learn More button a no-op on click
export const gSuppressLearnMoreLink = false;
// Icon name used for upgrade-locked indicators (badges, pills, buttons) across the app
export const gUpgradeIndicatorIcon = "gem";
